import { render, staticRenderFns } from "./EditAnnonce.vue?vue&type=template&id=c4c5b2b2&scoped=true"
import script from "./EditAnnonce.vue?vue&type=script&lang=js"
export * from "./EditAnnonce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c5b2b2",
  null
  
)

export default component.exports